import React, { useState } from "react";
import "./Header.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Helper to handle navigation - uses SPA navigation for internal links
const handleNavClick = (e, url) => {
  // External URLs (http/https) - let browser handle normally
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return; // Let the default anchor behavior work
  }

  // Internal URLs - use SPA navigation to preserve audio playback
  e.preventDefault();
  console.log('[Header] SPA navigation to:', url);
  window.dispatchEvent(new CustomEvent('navigateTo', { detail: { url } }));
};

const Header = () => {
  const cfg = window.__TENANT_CFG__ || {};

  // Use tenant STATION_NAME for text logo, fallback to default
  const stationName = cfg.STATION_NAME || "Radio Station";

  // Use logo from config if available, otherwise use text logo
  const logoImage = cfg.LOGO_URL || null;

  // fall back to static if no NAV_LINKS in config:
  const navLinks = cfg.NAV_LINKS || [
    { label: "HOME", url: "/" },
    { label: "MUSIC", url: "/music" },
    { label: "PODCASTS", url: "/podcasts" },
    { label: "EVENTS", url: "/events" },
    { label: "CONTACT", url: "/contact" },
  ];

  // similarly for socials:
  const social = cfg.SOCIAL || {
    X: "https://twitter.com/",
    INSTAGRAM: "https://www.instagram.com/",
    FACEBOOK: "https://www.facebook.com/",
    SNAPCHAT: "https://www.snapchat.com/",
    YOUTUBE: "https://www.youtube.com/",
  };

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <i className="fas fa-bars"></i>
      </button>

      {menuOpen && (
        <nav className={`mobile-menu ${menuOpen ? "open" : "closed"}`}>
          <ul>
            {navLinks.map(({ label, url }) => (
              <li key={label}>
                <a href={url} onClick={(e) => handleNavClick(e, url)}>{label}</a>
              </li>
            ))}
          </ul>
        </nav>
      )}
      <div className="left">
        {logoImage ? (
          <img
            src={logoImage}
            alt={`${cfg.TENANT_ID || "default"} logo`}
            className="logo"
          />
        ) : (
          <div className="text-logo">{stationName}</div>
        )}
      </div>
      <nav className="center">
        <ul>
          {navLinks.map(({ label, url }) => (
            <li key={label}>
              <a href={url} onClick={(e) => handleNavClick(e, url)}>{label}</a>
            </li>
          ))}
        </ul>
      </nav>
      {/* Social Icons */}
      <div className="right">
        {Object.entries(social).map(([k, url]) => (
          <a
            key={k}
            href={url}
            className="btIconWidget"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="btIconWidgetIcon">
              <i className={`fab fa-${k.toLowerCase()}`}></i>
            </div>
          </a>
        ))}
      </div>
    </header>
  );
};

export default Header;
